// @flow
import Icon from '~/core/icons';
import styled from 'styled-components';

export const HeaderContainer = styled.div`display: flex;`;

export const Subheading = styled.p`font-weight: bold;`;

export const WarningIcon = styled(Icon)`
    font-size: 2.5rem;
    color: ${props => props.theme.error};
`;

export const WiringTitle = styled.h1`
    font-size: 2rem;
    font-weight: normal;
    margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/wiring-error/styles.js